module.exports = __webpack_public_path__ + "static/media/smart-build.a4b35044.png";